var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStationsBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 20",
    filter: "url(#filter0_d_727_358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.36536,
    y: 1,
    width: 99,
    height: 100,
    rx: 15,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M40.3087 74.0178C39.6462 73.821 39.2176 73.3782 39.0227 72.6894C38.8279 72.0006 38.9838 71.4003 39.4904 70.8886L41.0101 69.3535C38.711 69.3535 36.7724 68.5565 35.1942 66.9623C33.616 65.3682 32.8269 63.41 32.8269 61.0877V38.6518C32.8269 37.038 33.1971 35.6308 33.9375 34.4303C34.6779 33.2298 35.8177 32.2457 37.3569 31.4782C38.8961 30.7106 40.8445 30.1399 43.202 29.766C45.5596 29.392 48.336 29.2051 51.5313 29.2051C54.8826 29.2051 57.7369 29.3822 60.0945 29.7365C62.452 30.0907 64.3809 30.6516 65.8812 31.4191C67.3814 32.1867 68.4823 33.1609 69.1837 34.3417C69.8851 35.5226 70.2358 36.9592 70.2358 38.6518V61.0877C70.2358 63.41 69.4467 65.3682 67.8685 66.9623C66.2903 68.5565 64.3517 69.3535 62.0526 69.3535L63.5723 70.8886C64.0789 71.4003 64.2348 72.0006 64.0399 72.6894C63.8451 73.3782 63.4165 73.821 62.754 74.0178C62.4423 74.0966 62.1208 74.0966 61.7896 74.0178C61.4583 73.9391 61.1758 73.7817 60.942 73.5455L56.792 69.3535H46.2707L42.1207 73.5455C41.8869 73.7817 41.6043 73.9391 41.2731 74.0178C40.9419 74.0966 40.6204 74.0966 40.3087 74.0178ZM51.5313 32.7476C46.8552 32.7476 43.4845 33.0526 41.4192 33.6627C39.354 34.2728 37.8732 35.1486 36.9769 36.2901H66.2611C65.5597 35.2273 64.0692 34.3712 61.7896 33.7218C59.51 33.0723 56.0906 32.7476 51.5313 32.7476ZM36.334 48.9841H50.0116V39.8326H36.334V48.9841ZM53.5187 48.9841H66.7287V39.8326H53.5187V48.9841ZM43.0559 62.5637C43.9521 62.5637 44.712 62.2488 45.3355 61.619C45.959 60.9893 46.2707 60.2217 46.2707 59.3164C46.2707 58.4111 45.959 57.6436 45.3355 57.0138C44.712 56.384 43.9521 56.0691 43.0559 56.0691C42.1596 56.0691 41.3998 56.384 40.7763 57.0138C40.1528 57.6436 39.8411 58.4111 39.8411 59.3164C39.8411 60.2217 40.1528 60.9893 40.7763 61.619C41.3998 62.2488 42.1596 62.5637 43.0559 62.5637ZM60.0068 62.5637C60.9031 62.5637 61.6629 62.2488 62.2864 61.619C62.9099 60.9893 63.2216 60.2217 63.2216 59.3164C63.2216 58.4111 62.9099 57.6436 62.2864 57.0138C61.6629 56.384 60.9031 56.0691 60.0068 56.0691C59.1105 56.0691 58.3507 56.384 57.7272 57.0138C57.1037 57.6436 56.792 58.4111 56.792 59.3164C56.792 60.2217 57.1037 60.9893 57.7272 61.619C58.3507 62.2488 59.1105 62.5637 60.0068 62.5637ZM41.0101 66.1062H62.0526C63.3775 66.1062 64.4881 65.6142 65.3843 64.6302C66.2806 63.6461 66.7287 62.4653 66.7287 61.0877V52.5266H36.334V61.0877C36.334 62.4653 36.7821 63.6461 37.6784 64.6302C38.5746 65.6142 39.6852 66.1062 41.0101 66.1062Z",
    fill: "#044535"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_727_358",
    x: 0.365356,
    y: 0,
    width: 103,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.117647 0 0 0 0 0.117647 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_727_358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_727_358",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStationsBtn);
export default __webpack_public_path__ + "static/media/StationsBtn.c2c4c78a816bc93ed007ed09eb2ea7a4.svg";
export { ForwardRef as ReactComponent };